import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { MapLayersState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: MapLayersState = getDefaultState();

const namespaced: boolean = true;

export const mapLayers: Module<MapLayersState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
